import { Config } from '../types';

export const config: Config = {
  ipifyBaseUrl: process.env.REACT_APP_IPIFY_BASE_URL,
  ipifyKey: process.env.REACT_APP_IPIFY_API_KEY,
};
